import ajax from '@/utils/request'

// 机构树
export const orgunitList = data => ajax('/api/orgunit/tree/', data, 'GET')
// 机构详情
export const orgunitDetail = data => ajax('/api/orgunit/get/', data, 'GET')
// 添加子机构
export const orgunitCreate = data => ajax('/api/orgunit/add/', data, 'POST')
// 编辑机构
export const orgunitEdit = data => ajax('/api/orgunit/edit/', data, 'POST')
// 删除机构
export const orgunitDel = data => ajax('/api/orgunit/del/', data, 'POST')
// 设置开关机模板
export const orgunitTemplate = data => ajax('/api/orgunit/save/orgunit/template/', data, 'POST')
// 恢复模板
export const orgunitDelTemplate = data => ajax('/api/orgunit/del/orgunit/template/', data, 'POST')
// 获取管理员
export const orgunitAdmins = data => ajax('/api/orgunit/get/admins/select/', data, 'POST')
